//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
//@core
const { FormattedText } = require('core/i18n').i18n;
//@commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
//@utils
const {
    capitalizeFirstLetter
} = require("utilities/stringHelper");

const buildTitle = (keyPrefix, noConditions, showBuildedTable) => {
    const keySufix = noConditions ? 'NoConditions' : 'Conditions';
    const titleClasses = classnames('mortgage-request-header-calculate-quota__table-container__title-info', {
        'mortgage-request-header-calculate-quota__table-container__title-info--conditions': noConditions
    });

    let titleKey = `${keyPrefix}title${keySufix}`;

    if (showBuildedTable) {
        titleKey = `${keyPrefix}buildedTableTitle${keySufix}`;
    }

    return (
        <FormattedText
            className={titleClasses}
            value={titleKey}
        />
    );
}

const buildSubtitle = (isMortgageTableEnabled, keyPrefix, noConditions, showBuildedTable, type) => {
    const keySufix = noConditions ? 'NoConditions' : 'Conditions';

    let subtitleKey = `calculateQuotaHeader-calculateQuotaHeader_${type}MortgageSubTitleModal`;

    if (isMortgageTableEnabled) {
        subtitleKey = `${keyPrefix}subtitle${keySufix}`;
    }

    if (showBuildedTable) {
        subtitleKey = `${keyPrefix}buildedTableSubtitle${keySufix}`;
    }

    return (
        <FormattedText
            className="mortgage-request-header-calculate-quota__table-container__subtitle-info"
            value={subtitleKey}
        />
    );
}

const buildTableCells = (cellsConfiguration, optionalIndex = '', keySufix) => {
    return cellsConfiguration.map((cellConfiguration, index) => {
        const { rowSpan } = cellConfiguration;
        return (
            rowSpan ?
            <td
                key={`${keySufix}${index}${optionalIndex}`}
                className={cellConfiguration.className}
                rowSpan={rowSpan}
            >
                {cellConfiguration.value}
            </td> :
            <OKTableCell
                key={`${keySufix}${index}${optionalIndex}`}
                asHeader={cellConfiguration.asHeader}
                className={cellConfiguration.className}
            >
                {cellConfiguration.value}
            </OKTableCell>
        );
    });
}

const buildTableHead = (cellsHeaderConfiguration, type, keySufix) => {
    const headerKey = ['first', 'second', 'third', 'fourth', 'fifth'];

    const headerCells = cellsHeaderConfiguration.map((cell, index) => ({
        asHeader: true,
        className: `mortgage-request-header-calculate-quota__table-container-${type}__title__row__table-head
            mortgage-request-header-calculate-quota__table-container-${type}__title__row__table-head--${type}-${headerKey[index]}-column`,
        value: cell,
    }));
    const tableHeadCells = buildTableCells(headerCells, 'headerCell', keySufix);

    return (
        <thead className={`mortgage-request-header-calculate-quota__table-container-${type}__title`}>
            <OKTableRow
                asHeader
                className={`mortgage-request-header-calculate-quota__table-container-${type}__title__row`}
            >
                {tableHeadCells}
            </OKTableRow>
        </thead>
    );
}

const buildTableBodyRow = (cellConfiguration, index, type, keySufix) => {
    const rowCells = buildTableCells(cellConfiguration, index, keySufix);
    return (
        <OKTableRow key={`${keySufix}bodyRow${index}`} className={`mortgage-request-header-calculate-quota__table-container-${type}__body__row`}>
            {rowCells}
        </OKTableRow>
    );
}

const buildTableBody = (cellsBodyConfiguration, type, keySufix) => {
    return (
        <tbody>
            {cellsBodyConfiguration.map((rowConfiguration, index) => buildTableBodyRow(rowConfiguration, `body${index}`, type, keySufix))}
        </tbody>
    );
}

const buildTable = (cellsBodyConfiguration, cellsHeaderConfiguration, type, keySufix) => {
    const tableHead = buildTableHead(cellsHeaderConfiguration, type, keySufix);
    const tableBody = buildTableBody(cellsBodyConfiguration, type, keySufix);

    return (
        <OKTable className={`mortgage-request-header-calculate-quota__table-container-${type}`}>
            {tableHead}
            {tableBody}
        </OKTable>
    );
}

const getBuildedTable = (keyPrefix, keySufix, type) => {
    const buildedTableKey = `${keyPrefix}buildedTable${keySufix}`;
    return (
        <FormattedText
            className={`mortgage-request-header-calculate-quota__${type}-builded-table-container`}
            value={buildedTableKey}
        />
    );
}

const RequestMortgageTable = props => {
    const {
        cellsBodyConfiguration,
        cellsHeaderConfiguration,
        isMortgageTableEnabled,
        noConditions,
        showBuildedTable,
        type,
        hideTitleSubtitle
    } = props;
    const keyPrefix = `calculateQuota${capitalizeFirstLetter(type)}MortgageTable-calculateQuota${capitalizeFirstLetter(type)}MortgageTable_`;
    const keySufix = noConditions ? 'NoConditions' : 'Conditions';

    const title = isMortgageTableEnabled || showBuildedTable ? buildTitle(keyPrefix, noConditions, showBuildedTable) : null;
    const subtitle = buildSubtitle(isMortgageTableEnabled, keyPrefix, noConditions, showBuildedTable, type);
    const tableContent = showBuildedTable ? 
        getBuildedTable(keyPrefix, keySufix, type) :
        buildTable(cellsBodyConfiguration, cellsHeaderConfiguration, type, keySufix);

    return (
        <React.Fragment>
            {!hideTitleSubtitle && title}
            {!hideTitleSubtitle && subtitle}
            {tableContent}
        </React.Fragment>
    )
}

RequestMortgageTable.propTypes = {
    cellsBodyConfiguration: PropTypes.arrayOf(PropTypes.array).isRequired,
    cellsHeaderConfiguration: PropTypes.arrayOf(PropTypes.any).isRequired,
    isMortgageTableEnabled: PropTypes.bool.isRequired,
    noConditions: PropTypes.bool.isRequired,
    showBuildedTable: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
};

RequestMortgageTable.defaultProps = {
    noConditions: false,
    showBuildedTable: false,
}

module.exports = RequestMortgageTable;
